module.exports = __webpack_public_path__ + "img/app_store_badge.f6982e11.svg";